<template>
  <div class="subjects-wrapper">
    <h2>
      Ваши предметы
    </h2>
    <div class="row">
      <div @click="goToCourseAssets(course.id)" class="col-lg-4" v-for="course in myCourses">
        <div class="card bg-primary cursor-pointer text-white">
          <div class="card-body">
            <h4 class="card-title text-white"> {{ course.subject.name }} - {{ course.name }} </h4>
            <p class="card-text">  </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('courses');

export default {
  name: "index",
  computed: {
    ...mapState({
      myCourses: (state) => state.myCourses,
    }),
  },
  methods: {
    ...mapActions(['getMyCourses']),
    goToCourseAssets(id){
      this.$router.push({name: 'subject.view', params: {id: id}})
    },
  },
  created() {
    this.getMyCourses();
  },
}
</script>

<style scoped>

</style>
